export class CurbsideInfo {
    Model: string;
    Make: string;
    Color: string;
}
